import React from 'react';
import ReactDOM from 'react-dom';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';

import AppRouter from './AppRouter';
import { Utils } from './services';
import { unregister } from './registerServiceWorker';
import './assets/index.css';

const muiTheme = getMuiTheme({
    palette: {
        primary1Color: '#002f6c',
        accent1Color: '#002f6c',
    },
});

const init = () => {
    ReactDOM.render(
        <MuiThemeProvider muiTheme={muiTheme}>
            <AppRouter />
        </MuiThemeProvider>,
        document.getElementById('root'),
    );

    unregister();
};

const verificarUsuarioEstaLogado = async () => {
    try {
        await Utils.getInformacoesPessoaLogada();
        Utils.setUsuarioEstaLogado(true);
    } catch (error) {
        Utils.setUsuarioEstaLogado(false);
    }
    init();
};

verificarUsuarioEstaLogado();
